import { Service, Inject } from 'vue-di-container';
import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { SuggestionsAndSystemEnhancementModel } from './SuggestionsAndSystemEnhancementModel';

@Service()
export default class SuggestionsAndSystemEnhancementService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;


    public async addSuggestion(
        model: SuggestionsAndSystemEnhancementModel
    ): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/suggestions';
            const result = await this.axiosService.axiosInstance.post(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            return error;
        }
    }

    public async getSuggestions(model: {
        providerName: string;
        service: string;
        pageIndex: string;
        pagesize: string;
    }): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/suggestions'
                + '?providerName=' + encodeURIComponent(model.providerName)
                + '&service=' + encodeURIComponent(model.service)
                + '&pageIndex=' + model.pageIndex
                + '&pageSize=' + model.pagesize;

            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async getById(
        id: string
    ): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = `${window.$config.HostName}api/suggestions/${id}`;
            const response = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return response.data;
        } catch (error) {
            this.loaderService.HideLoader();
            return error;
        }
    }
}
